module.exports = __webpack_public_path__ + "static/img/1038.dede764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1038.jpg
// module id = 220
// module chunks = 0